<h2 class="h6">E-Mail-Adresse</h2>

<form #form="ngForm" (ngSubmit)="onSubmit()">
  <ui-form-text [data]="itemEmailCurrent" [formControl]="emailCurrentControl"></ui-form-text>
  <ui-form-markup [data]="itemMarkup"></ui-form-markup>
  <ui-form-text [data]="itemEmailNew" [formControl]="emailNewControl"></ui-form-text>
  <ui-form-text [data]="itemEmailConfirm" [formControl]="emailConfirmControl"></ui-form-text>

  @if (hasPending()) {
    <ui-alert
      message="Ihre Anfrage zum Ändern der E-Mail-Adresse ist aktuell bei unserem Support in Bearbeitung."
      theme="info"
    ></ui-alert>
  }

  <ui-form-submit [data]="itemSubmit"></ui-form-submit>
</form>
